const mutations = {
    SetQuestionInfo(state, info) {
        state.questionInfo = info

        sessionStorage.setItem('questionInfo', info)
    },
    // 初次访谈标识 isNew 1:新访谈记录表 0 :旧访谈记录表
    setFirstInterViewType(state,isNewFirstInterView){
        state.isNewFirstInterView = isNewFirstInterView
    }
    
}
export default mutations


// WEBPACK FOOTER //
// ./src/store/mutations.js